module.exports = __webpack_public_path__ + "static/3-64bdd5bc34b953d2e37a3dd8004d8baf.svg";